module.exports = __webpack_public_path__ + "img/receipt34.ec4bb5b4.svg";